import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-user',
  templateUrl: './reset-user.component.html',
  styleUrls: ['./reset-user.component.css']
})
export class ResetUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
